/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { models_BillingSettings } from '../models/models_BillingSettings';
import type { models_Childcare } from '../models/models_Childcare';
import type { models_ChildcareAudit } from '../models/models_ChildcareAudit';
import type { models_CustomEnum } from '../models/models_CustomEnum';
import type { models_CustomEnumAudit } from '../models/models_CustomEnumAudit';
import type { models_DunningSettings } from '../models/models_DunningSettings';
import type { models_EffectiveSettings } from '../models/models_EffectiveSettings';
import type { models_Organisation } from '../models/models_Organisation';
import type { models_OrganisationAudit } from '../models/models_OrganisationAudit';
import type { models_QRReferenceCutoverPreview } from '../models/models_QRReferenceCutoverPreview';
import type { models_TableConfig } from '../models/models_TableConfig';
import type { models_TableConfigAudit } from '../models/models_TableConfigAudit';
import type { organisations_AbsenceSettingsResponse } from '../models/organisations_AbsenceSettingsResponse';
import type { organisations_CapacitySettingsRequest } from '../models/organisations_CapacitySettingsRequest';
import type { organisations_CapacitySettingsResponse } from '../models/organisations_CapacitySettingsResponse';
import type { organisations_DunningSettingsResponse } from '../models/organisations_DunningSettingsResponse';
import type { organisations_PaginatedResponse } from '../models/organisations_PaginatedResponse';
import type { organisations_ShiftSettingsResponse } from '../models/organisations_ShiftSettingsResponse';
import type { organisations_TimezoneSettingsRequest } from '../models/organisations_TimezoneSettingsRequest';
import type { organisations_TimezoneSettingsResponse } from '../models/organisations_TimezoneSettingsResponse';
import type { organisations_UpdateAbsenceSettingsRequest } from '../models/organisations_UpdateAbsenceSettingsRequest';
import type { organisations_UpdateShiftSettingsRequest } from '../models/organisations_UpdateShiftSettingsRequest';
import type { organisations_WorkflowSettingsRequest } from '../models/organisations_WorkflowSettingsRequest';
import type { organisations_WorkflowSettingsResponse } from '../models/organisations_WorkflowSettingsResponse';
import type { shared_CreateChildcareRequest } from '../models/shared_CreateChildcareRequest';
import type { shared_CreateCustomEnumRequest } from '../models/shared_CreateCustomEnumRequest';
import type { shared_CreateTableConfigRequest } from '../models/shared_CreateTableConfigRequest';
import type { shared_UpdateChildcareRequest } from '../models/shared_UpdateChildcareRequest';
import type { shared_UpdateCustomEnumRequest } from '../models/shared_UpdateCustomEnumRequest';
import type { shared_UpdateOrganisationRequest } from '../models/shared_UpdateOrganisationRequest';
import type { shared_UpdateTableConfigRequest } from '../models/shared_UpdateTableConfigRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrganisationSettingsService {
    /**
     * Delete childcare
     * Soft delete a childcare location
     * @param id Childcare ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Childcares(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/childcares/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update childcare
     * Update childcare details
     * @param id Childcare ID
     * @param request Update request
     * @returns models_Childcare OK
     * @throws ApiError
     */
    public static putApiV1Childcares(
        id: string,
        request: shared_UpdateChildcareRequest,
    ): CancelablePromise<models_Childcare> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/childcares/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get childcare audit history
     * Get audit history for a childcare
     * @param id Childcare ID
     * @param limit Limit
     * @param offset Offset
     * @returns models_ChildcareAudit OK
     * @throws ApiError
     */
    public static getApiV1ChildcaresHistory(
        id: string,
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<Array<models_ChildcareAudit>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/childcares/{id}/history',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List custom enums
     * List all custom enums for the organisation
     * @returns models_CustomEnum OK
     * @throws ApiError
     */
    public static getApiV1CustomEnums(): CancelablePromise<Array<models_CustomEnum>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/custom-enums',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create custom enum
     * Create a new custom enum value
     * @param request Create request
     * @returns models_CustomEnum Created
     * @throws ApiError
     */
    public static postApiV1CustomEnums(
        request: shared_CreateCustomEnumRequest,
    ): CancelablePromise<models_CustomEnum> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/custom-enums',
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete custom enum
     * Soft delete a custom enum
     * @param id Custom enum ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1CustomEnums(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/custom-enums/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update custom enum
     * Update custom enum details
     * @param id Custom enum ID
     * @param request Update request
     * @returns models_CustomEnum OK
     * @throws ApiError
     */
    public static putApiV1CustomEnums(
        id: string,
        request: shared_UpdateCustomEnumRequest,
    ): CancelablePromise<models_CustomEnum> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/custom-enums/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get custom enum audit history
     * Get audit history for a custom enum
     * @param id Custom enum ID
     * @param limit Limit
     * @param offset Offset
     * @returns models_CustomEnumAudit OK
     * @throws ApiError
     */
    public static getApiV1CustomEnumsHistory(
        id: string,
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<Array<models_CustomEnumAudit>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/custom-enums/{id}/history',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get organisation details
     * Get details of the current organisation
     * @param id Organisation ID
     * @returns models_Organisation OK
     * @throws ApiError
     */
    public static getApiV1Organisations(
        id: string,
    ): CancelablePromise<models_Organisation> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organisations/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update organisation
     * Update organisation details
     * @param id Organisation ID
     * @param request Update request
     * @returns models_Organisation OK
     * @throws ApiError
     */
    public static putApiV1Organisations(
        id: string,
        request: shared_UpdateOrganisationRequest,
    ): CancelablePromise<models_Organisation> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organisations/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get absence settings
     * Returns the doctor's-certificate rules for reported absences (issue #1767): certificate mode, due day per report type and retention period. Missing stored keys read as defaults (UPLOAD, 4/4/4, 24), so the response is always the full shape. Admins, `employees` and `shifts-absences` holders may read it.
     * @param id Organisation ID
     * @returns organisations_AbsenceSettingsResponse OK
     * @throws ApiError
     */
    public static getApiV1OrganisationsAbsenceSettings(
        id: string,
    ): CancelablePromise<organisations_AbsenceSettingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organisations/{id}/absence-settings',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid organisation ID`,
                401: `Authentication required`,
                403: `Module access required or other organisation`,
                500: `Failed to retrieve absence settings`,
            },
        });
    }
    /**
     * Update absence settings
     * Replaces the doctor's-certificate rules for reported absences (issue #1767). The body must carry the full shape: certificateMode (UPLOAD or EAU), certificateDueDay with SICK, ACCIDENT and CHILD_SICK (1-30 each) and certificateRetentionMonths (6-120). Admin only.
     * @param id Organisation ID
     * @param settings Absence settings
     * @returns organisations_AbsenceSettingsResponse OK
     * @throws ApiError
     */
    public static putApiV1OrganisationsAbsenceSettings(
        id: string,
        settings: organisations_UpdateAbsenceSettingsRequest,
    ): CancelablePromise<organisations_AbsenceSettingsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organisations/{id}/absence-settings',
            path: {
                'id': id,
            },
            body: settings,
            errors: {
                400: `Invalid organisation ID or request format`,
                401: `Authentication required`,
                403: `Administrator access required or other organisation`,
                422: `Validation failed (field map, or ABSENCE_SETTINGS_INVALID from the service re-check)`,
                500: `Failed to update absence settings`,
            },
        });
    }
    /**
     * Get billing settings
     * Get billing settings for an organisation
     * @param id Organisation ID
     * @returns models_BillingSettings OK
     * @throws ApiError
     */
    public static getApiV1OrganisationsBillingSettings(
        id: string,
    ): CancelablePromise<models_BillingSettings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organisations/{id}/billing-settings',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update billing settings
     * Update billing settings for an organisation
     * @param id Organisation ID
     * @param settings Billing settings
     * @returns models_BillingSettings OK
     * @throws ApiError
     */
    public static putApiV1OrganisationsBillingSettings(
        id: string,
        settings: models_BillingSettings,
    ): CancelablePromise<models_BillingSettings> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organisations/{id}/billing-settings',
            path: {
                'id': id,
            },
            body: settings,
            errors: {
                400: `Invalid request, enabled subsidy rounding adoption without a threshold above 0, a BESR-ID that is not exactly 6 digits, or an invoice due-date rule without the days (1-90) or day of month (1-28) its mode needs (INVALID_BILLING_SETTINGS)`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `BESR-ID change refused: invoices were already delivered by email (QRR_SCHEME_LOCKED)`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Preview a BESR-ID change
     * Reports how many stored QR references saving a changed BESR-ID would recompute, and whether the change is locked because an invoice email was already delivered (issue #1756).
     * @param id Organisation ID
     * @returns models_QRReferenceCutoverPreview OK
     * @throws ApiError
     */
    public static getApiV1OrganisationsBillingSettingsQrReferenceCutover(
        id: string,
    ): CancelablePromise<models_QRReferenceCutoverPreview> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organisations/{id}/billing-settings/qr-reference-cutover',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get capacity settings
     * Get capacity settings for an organisation (returns defaults if not configured)
     * @param id Organisation ID
     * @returns organisations_CapacitySettingsResponse OK
     * @throws ApiError
     */
    public static getApiV1OrganisationsCapacitySettings(
        id: string,
    ): CancelablePromise<organisations_CapacitySettingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organisations/{id}/capacity-settings',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update capacity settings
     * Update capacity settings for an organisation
     * @param id Organisation ID
     * @param settings Capacity settings
     * @returns organisations_CapacitySettingsResponse OK
     * @throws ApiError
     */
    public static putApiV1OrganisationsCapacitySettings(
        id: string,
        settings: organisations_CapacitySettingsRequest,
    ): CancelablePromise<organisations_CapacitySettingsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organisations/{id}/capacity-settings',
            path: {
                'id': id,
            },
            body: settings,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List childcares
     * List all childcares for an organisation
     * @param id Organisation ID
     * @param limit Limit
     * @param offset Offset
     * @returns organisations_PaginatedResponse OK
     * @throws ApiError
     */
    public static getApiV1OrganisationsChildcares(
        id: string,
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<organisations_PaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organisations/{id}/childcares',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create childcare
     * Create a new childcare location
     * @param id Organisation ID
     * @param request Create request
     * @returns models_Childcare Created
     * @throws ApiError
     */
    public static postApiV1OrganisationsChildcares(
        id: string,
        request: shared_CreateChildcareRequest,
    ): CancelablePromise<models_Childcare> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organisations/{id}/childcares',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get dunning settings
     * Get dunning (payment-reminder) settings for an organisation. Returns documented defaults if not yet configured. The response also carries `sweeper_active` and `sweeper_inactive_reason`, the RUNTIME state of the dunning sweeper — a separate question from the stored `enabled` flag. The sweeper only starts when an email sender is configured, and a missing RESEND_API_KEY logs a warning rather than failing startup, so an organisation can read `enabled: true` while no reminder can ever be sent. Show the warning on `sweeper_active: false`. `final_notice_grace_days` (5-60, default 14) is the payment deadline the final notice states; a missing or 0 stored value reads as 14.
     * @param id Organisation ID
     * @returns organisations_DunningSettingsResponse OK
     * @throws ApiError
     */
    public static getApiV1OrganisationsDunningSettings(
        id: string,
    ): CancelablePromise<organisations_DunningSettingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organisations/{id}/dunning-settings',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update dunning settings
     * Update dunning settings for an organisation. Whenever the persisted result has `enabled = true`, default templates are seeded for the org if none exist (idempotent — no-op when any active templates are present). `final_notice_grace_days` (5-60, default 14) is the payment deadline the final notice states; a missing or 0 value is stored as 14.
     * @param id Organisation ID
     * @param settings Dunning settings
     * @returns models_DunningSettings OK
     * @throws ApiError
     */
    public static putApiV1OrganisationsDunningSettings(
        id: string,
        settings: models_DunningSettings,
    ): CancelablePromise<models_DunningSettings> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organisations/{id}/dunning-settings',
            path: {
                'id': id,
            },
            body: settings,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get organisation audit history
     * Get audit history for an organisation
     * @param id Organisation ID
     * @param limit Limit
     * @param offset Offset
     * @returns models_OrganisationAudit OK
     * @throws ApiError
     */
    public static getApiV1OrganisationsHistory(
        id: string,
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<Array<models_OrganisationAudit>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organisations/{id}/history',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get shift settings
     * Returns the planner warning limits (issue #2042): publication lead time in days, net day length, week length over the contract hours and rest between two working days, in minutes. Missing stored keys read as defaults (14, 600, 600, 660); 0 means the warning is off. Admins and `shifts-absences` holders may read it.
     * @param id Organisation ID
     * @returns organisations_ShiftSettingsResponse OK
     * @throws ApiError
     */
    public static getApiV1OrganisationsShiftSettings(
        id: string,
    ): CancelablePromise<organisations_ShiftSettingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organisations/{id}/shift-settings',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid organisation ID`,
                401: `Authentication required`,
                403: `Module access required or other organisation`,
                500: `Failed to retrieve shift settings`,
            },
        });
    }
    /**
     * Update shift settings
     * Replaces the planner warning limits (issue #2042). The body must carry the full shape: publishLeadDays (0-90), maxDayMinutes (0-1440), weekOverContractMinutes (0-2400) and minRestMinutes (0-1440). 0 switches a warning off. The planner only warns; nothing is blocked. Admin only.
     * @param id Organisation ID
     * @param settings Shift settings
     * @returns organisations_ShiftSettingsResponse OK
     * @throws ApiError
     */
    public static putApiV1OrganisationsShiftSettings(
        id: string,
        settings: organisations_UpdateShiftSettingsRequest,
    ): CancelablePromise<organisations_ShiftSettingsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organisations/{id}/shift-settings',
            path: {
                'id': id,
            },
            body: settings,
            errors: {
                400: `Invalid organisation ID or request format`,
                401: `Authentication required`,
                403: `Administrator access required or other organisation`,
                422: `Validation failed (field map, or SHIFT_SETTINGS_INVALID from the service re-check)`,
                500: `Failed to update shift settings`,
            },
        });
    }
    /**
     * Get organisation timezone
     * Get the IANA timezone the organisation's date boundaries are computed in
     * @param id Organisation ID
     * @returns organisations_TimezoneSettingsResponse OK
     * @throws ApiError
     */
    public static getApiV1OrganisationsTimezone(
        id: string,
    ): CancelablePromise<organisations_TimezoneSettingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organisations/{id}/timezone',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update organisation timezone
     * Set the IANA timezone the organisation's date boundaries are computed in
     * @param id Organisation ID
     * @param settings Organisation timezone
     * @returns organisations_TimezoneSettingsResponse OK
     * @throws ApiError
     */
    public static putApiV1OrganisationsTimezone(
        id: string,
        settings: organisations_TimezoneSettingsRequest,
    ): CancelablePromise<organisations_TimezoneSettingsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organisations/{id}/timezone',
            path: {
                'id': id,
            },
            body: settings,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get workflow settings
     * Get workflow settings for an organisation (returns defaults if not configured)
     * @param id Organisation ID
     * @returns organisations_WorkflowSettingsResponse OK
     * @throws ApiError
     */
    public static getApiV1OrganisationsWorkflowSettings(
        id: string,
    ): CancelablePromise<organisations_WorkflowSettingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organisations/{id}/workflow-settings',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update workflow settings
     * Update workflow settings for an organisation
     * @param id Organisation ID
     * @param settings Workflow settings
     * @returns organisations_WorkflowSettingsResponse OK
     * @throws ApiError
     */
    public static putApiV1OrganisationsWorkflowSettings(
        id: string,
        settings: organisations_WorkflowSettingsRequest,
    ): CancelablePromise<organisations_WorkflowSettingsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organisations/{id}/workflow-settings',
            path: {
                'id': id,
            },
            body: settings,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get effective settings
     * Get effective settings with inheritance (system → org → childcare). Staff-accessible: this is the only lawful read path for a non-admin educator's mobile capture screen, since every /api/v1/settings/portfolio* route is admin-only including reads. Carries `portfolioDomains`, `portfolioScales`, `portfolioTemplates` and `portfolioCapture` (`defaultScaleKeys` — always an array, never null — `defaultTemplateKey`, `requireDomainOnDocument`). The retention policy is deliberately NOT exposed. `voiceInputEnabled` says whether this deployment can parse dictation (false unless OPENAI_API_KEY is set and VOICE_OPENAI_ENABLED is true).
     * @param childcareId Childcare ID
     * @returns models_EffectiveSettings OK
     * @throws ApiError
     */
    public static getApiV1SettingsEffective(
        childcareId?: string,
    ): CancelablePromise<models_EffectiveSettings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/settings/effective',
            query: {
                'childcareId': childcareId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get all enums hierarchy
     * Get all enums at all hierarchy levels (system + org + childcare) for settings UI
     * @param childcareId Childcare ID
     * @returns models_EffectiveSettings OK
     * @throws ApiError
     */
    public static getApiV1SettingsHierarchy(
        childcareId?: string,
    ): CancelablePromise<models_EffectiveSettings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/settings/hierarchy',
            query: {
                'childcareId': childcareId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List table configs
     * List all table configs for the organisation
     * @returns models_TableConfig OK
     * @throws ApiError
     */
    public static getApiV1TableConfigs(): CancelablePromise<Array<models_TableConfig>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/table-configs',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create table config
     * Create a new table configuration
     * @param request Create request
     * @returns models_TableConfig Created
     * @throws ApiError
     */
    public static postApiV1TableConfigs(
        request: shared_CreateTableConfigRequest,
    ): CancelablePromise<models_TableConfig> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/table-configs',
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete table config
     * Soft delete a table configuration
     * @param id Table config ID
     * @param entityType Entity type
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1TableConfigs(
        id: string,
        entityType: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/table-configs/{id}',
            path: {
                'id': id,
            },
            query: {
                'entity_type': entityType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update table config
     * Update table configuration
     * @param id Table config ID
     * @param request Update request
     * @returns models_TableConfig OK
     * @throws ApiError
     */
    public static putApiV1TableConfigs(
        id: string,
        request: shared_UpdateTableConfigRequest,
    ): CancelablePromise<models_TableConfig> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/table-configs/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get table config audit history
     * Get audit history for a table config
     * @param id Table config ID
     * @param limit Limit
     * @param offset Offset
     * @returns models_TableConfigAudit OK
     * @throws ApiError
     */
    public static getApiV1TableConfigsHistory(
        id: string,
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<Array<models_TableConfigAudit>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/table-configs/{id}/history',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
}
